<template>
  <div class="ui-orders-row-details">
    <div class="d-flex justify-content-center m-3" v-if="loading">
      <CSpinner color="info" />
    </div>

    <OrdersTableDetailRows
      ref="details"
      :show="!loading"
      :grid="grid"
      :parentData="data"
      :parentRowIndex="parentRowIndex"
      :rows="rows"
      :statusMap="statusMap"
      :cols="['product', 'productType']"
      :actLabel="
        $t(
          'role.orders.manage.ddmp.detail.delivery.table.products.table.actions.delivered'
        )
      "
      :skipDirectDelivery="true"
      @onActionSelect="onActionSelect"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Query, Predicate } from "@syncfusion/ej2-data";
import { GetDataManagerNew } from "../../../../../../ds";
import {
  addAndPredicateFilter,
  buildPredicate,
} from "../../../../../../helpers/common";
import {
  INCIDENT_ENTITY_TYPE,
  INCIDENT_TYPE,
  ORDER_ACTION,
  producersProgressMap,
} from "../../../../../../config/global";
import EventBus from "../../../../../../helpers/EventBus";
import orderManagementMixin from "../../../share/mixin";
import { filtersMap } from "../../filtersMap";
import OrdersTableDetailRows from "../../../share/OrdersTableDetailRows";

export default {
  name: "OrdersTableRowDetails",

  components: {
    OrdersTableDetailRows,
  },

  mixins: [orderManagementMixin],

  props: {
    grid: {
      type: Object,
      required: true,
    },
    ddmp: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      rows: [],
      parentRowIndex: null,
    };
  },

  computed: {
    lang: function () {
      return this.$i18n.locale;
    },

    ...mapGetters("connections", ["currencySymbol"]),

    statusMap() {
      return producersProgressMap(this.$i18n);
    },
  },

  watch: {
    selected(val) {
      EventBus.$emit("orders:detail", {
        parentId: this.data.id,
        selected: [...val],
      });
    },
  },

  mounted() {
    this.bindRowDetailsEvents();
    this.loadData();
  },

  beforeDestroy() {
    this.unbindRowDetailsEvents();
  },

  methods: {
    loadData() {
      const self = this;
      const roleId = this.$store.state.role.id;
      const orderId = this.data.order.order.id;
      const ddmpId = this.ddmp.ddmp.id;
      const endpoint = filtersMap("ddmp.panel2.detail.endpoint");
      const dm = GetDataManagerNew(endpoint, [roleId]);
      const query = this.prepareQuery(orderId, ddmpId);
      self.loading = true;

      dm.executeQuery(query)
        .then((response) => {
          self.loading = false;
          self.rows = response.result;

          const parentSelectedIds = self.grid
            .getSelectedRecords()
            .map((item) => item.id);
          if (parentSelectedIds.includes(self.data.id)) {
            self.selectAll();
          }
        })
        .catch((response) => {
          self.loading = false;
          console.error(response);
        });
    },

    prepareQuery(orderId, ddmpId) {
      const { keyword } = this.$store.state.orders.filters;

      let predicate = new Predicate("order.id", "equal", orderId);
      predicate = addAndPredicateFilter(predicate, "ddmp", "equal", ddmpId);

      const map = filtersMap("ddmp.panel2.detail.filters");
      predicate = buildPredicate(
        predicate,
        map,
        this.$store.state.orders.filters
      );

      let query = new Query().where(predicate);

      const searchFields = filtersMap("ddmp.panel2.detail.search", []);
      if (keyword && searchFields.length > 0) {
        query = query.search(keyword, searchFields);
      }

      return query;
    },

    onActionSelect({ args, row }) {
      const details = [row.id];

      if (args.item.id === ORDER_ACTION.DONE) {
        // console.log(this.ddmp)
        let next_status = filtersMap("ddmp.statusCode.next");
        if (this.ddmp.ddmp.delivery_type == 3) {
          next_status = filtersMap("ddmiIsland.statusCode.next");
        }
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: next_status,
            details,
          })
          .then(this.onUpdateStatusSuccess);
      }

      if (args.item.id === ORDER_ACTION.UNDONE) {
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: filtersMap("ddmp.statusCode.prev"),
            details,
          })
          .then(this.onUpdateStatusSuccess);
      }

      if (args.item.id === ORDER_ACTION.INCIDENT) {
        this.$store.commit("incidents/createResetAllEntities");
        this.$store.commit("incidents/createAddEntities", {
          entities: [
            { type: INCIDENT_ENTITY_TYPE.DETAILS, items: [{ ...row }] },
          ],
          type: INCIDENT_TYPE.INCIDENT,
          show: true,
        });
      }

      if (args.item.id === ORDER_ACTION.CANCELLATION) {
        this.$store.commit("incidents/createResetAllEntities");
        this.$store.commit("incidents/createAddEntities", {
          entities: [
            { type: INCIDENT_ENTITY_TYPE.DETAILS, items: [{ ...row }] },
          ],
          type: INCIDENT_TYPE.CANCELLATION,
          show: true,
        });
      }
    },
  },
};
</script>
